import customAxios from '../../customHook/customAxios';
import { getAuthHeader } from '../../utils';

export const v2_submitted_potential_variable_order_form = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/site-management/submitted-potential-variable-order-form`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_site_management_stats = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/site-management/stats`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
